import { render, staticRenderFns } from "./ResultAssetParameter.vue?vue&type=template&id=72b09993&"
import script from "./ResultAssetParameter.vue?vue&type=script&lang=ts&"
export * from "./ResultAssetParameter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports